module.exports = __webpack_public_path__ + "assets/fonts/GothamProNarrow-Bold.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/gothampro/GothamProNarrow-Bold.ttf
// module id = 1909
// module chunks = 0